module.exports = __webpack_public_path__ + "static/media/r206.8c390d09.jpg";